var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.5,
    height: 68.1,
    viewBox: "0 0 85.5 68.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "noun-engine-137013",
    transform: "translate(-6.5 -16)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M92,40.5A4.481,4.481,0,0,0,87.5,36h-19A4.481,4.481,0,0,1,64,31.5h0A4.481,4.481,0,0,0,59.5,27h-22A4.481,4.481,0,0,0,33,31.5h0A4.481,4.481,0,0,1,28.5,36h-6A4.481,4.481,0,0,0,18,40.5v30A4.481,4.481,0,0,0,22.5,75H33.2a4.474,4.474,0,0,1,4,2.4l2.3,4.3a4.474,4.474,0,0,0,4,2.4H69a4.5,4.5,0,0,0,4.1-2.7l5.8-13.5A4.347,4.347,0,0,1,83,65.2h4.4a4.481,4.481,0,0,0,4.5-4.5V40.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M60.5,16h-24A2.476,2.476,0,0,0,34,18.5h0A2.476,2.476,0,0,0,36.5,21H46v3h6V21h8.5A2.476,2.476,0,0,0,63,18.5h0A2.476,2.476,0,0,0,60.5,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M6.5,43.5v24A2.476,2.476,0,0,0,9,70H9a2.476,2.476,0,0,0,2.5-2.5V58h3V52h-3V43.5A2.476,2.476,0,0,0,9,41H9A2.476,2.476,0,0,0,6.5,43.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.d0c03c0601247ebadb1b91d4a99424b0.svg";
export { ForwardRef as ReactComponent };